'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.notify_list_index', {
        url: 'notify_list',
        template: '<notify-list-index></notify-list-index>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/notify_list/index/notify_list_index.routes.js